import React from 'react';
import { Switch, Route } from 'react-router-dom';
import routes from './config/routes';
import pages from './pages';
import { isDevelopment } from './utils';

function Router() {
  return (
    <Switch>
      {routes.map(({ path, component }) => {
        if (isDevelopment() && !component) {
          throw new Error(`Page component not found for url ${path}`);
        }
        return <Route key={path} exact path={path} component={component} />;
      })}
      <Route key={404} component={pages.common.error404} />
    </Switch>
  );
}

export default Router;
